<!-- @format -->

<sis-study-substitution-box
  data-cy="plan-structure-course-unit-substitution"
  [substituteCourseUnits]="substituteCourseUnits()"
  [level]="headingLevel()"
  [showCompletionMethodSelection]="showCompletionMethodSelection()"
  [courseUnitsById]="planStructureContext.planData()?.courseUnitsById"
  [showAttainment]="showAttainment()"
  [action]="action()"
  [selected]="selected()"
  [inputType]="inputType()"
  [actionInputId]="actionInputId()"
  [actionInputName]="actionInputName()"
  [studyInfo]="(substitutedCourseUnit().name | localizedString) + ' ' + (substitutedCourseUnit().credits | creditRange)"
  (actionChange)="actionChange.emit()"
  substitutionTextVariant="student"
  (nameClickAction)="openCourseUnitInfoModal($event)"
  (editSubstitutionAction)="openSelectSubstitutionModal()">
</sis-study-substitution-box>
